// extracted by mini-css-extract-plugin
export default {"zoomModal":"BZ-z","image":"CZ-z","button":"DZ-z","isOverlayShown":"EZ-z"};